module.exports = __webpack_public_path__ + "static/media/808RowLabel--MT.c8563d85.svg";